module.exports = __webpack_public_path__ + "img/sweden-pneumonia-male.2ddeae17.png";